<div *ngIf="this.user.userInfo.EmployeeName">
    <button
        pButton
        id="userMenuButton"
        [label]="this.employeeName"
        icon="pi pi-chevron-down"
        iconPos="left"
        [matMenuTriggerFor]="usermenu"
        style="font-size: 16px; background-color: #007bff00"
    ></button>
    <div class="matMenu">
        <mat-menu
            #usermenu="matMenu"
            xPosition="before"
            yPosition="below"
            class="mat-menu"
            [overlapTrigger]="false"
        >
            <ef-user-role [roleGroupName]="roleGroupName"></ef-user-role>
            <ef-sign-in></ef-sign-in>
        </mat-menu>
    </div>
</div>
